import { RoomV2Entity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomCreateCmd,
  RoomDeleteCmd,
  RoomsListCmd,
  RoomUpdate2Cmd
} from "@youm-front/room/domain";

export const roomCreate = createAction(
  "[Room] Room Create",
  props<{
    roomCreateCmd: RoomCreateCmd;
  }>()
);
export const roomCreateSuccess = createAction(
  "[Room] Room Create Success",
  props<{
    room: RoomV2Entity;
  }>()
);
export const roomCreateFailure = createAction(
  "[Room] Room Create Failure",
  props<{
    message: string;
  }>()
);

export const roomDelete = createAction(
  "[Room] Room Delete",
  props<{
    roomDeleteCmd: RoomDeleteCmd;
  }>()
);
export const roomDeleteSuccess = createAction(
  "[Room] Room Delete Success",
  props<{
    roomDeleteCmd: RoomDeleteCmd;
  }>()
);
export const roomDeleteFailure = createAction(
  "[Room] Room Delete Failure",
  props<{
    message: string;
  }>()
);

export const roomUpdate = createAction(
  "[Room] Room Update",
  props<{
    roomUpdateCmd: RoomUpdate2Cmd;
  }>()
);
export const roomUpdateSuccess = createAction(
  "[Room] Room Update Success",
  props<{
    room: RoomV2Entity;
  }>()
);
export const roomUpdateFailure = createAction(
  "[Room] Room Update Failure",
  props<{
    message: string;
  }>()
);

export const roomsList = createAction(
  "[Room] Rooms List",
  props<{
    roomsListCmd: RoomsListCmd;
  }>()
);
export const roomsListSuccess = createAction(
  "[Room] Rooms List Success",
  props<{ rooms: RoomV2Entity[] }>()
);
export const roomsListFailure = createAction(
  "[Room] Rooms List Failure",
  props<{ message: string }>()
);
